//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Bus from '@/util/eventBus';
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
export default {
  components: {
    Avatar: Avatar
  },
  computed: {
    bulletin: function bulletin() {
      return window.setting.公告 || '';
    }
  },
  methods: {
    showRule: function showRule() {
      Bus.$emit('showRule');
    },
    openVideo: function openVideo() {
      Bus.$emit('openVideo');
    }
  }
};